<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{ 'modules.clients.associations.associationViewDialog.title' | translate }}</div>
    <div (click)="closeDialog(false)" class="dialog-close">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content tab-container">
    <div class="tab-actions-container">
        <button [matMenuTriggerFor]="addObjectMenu"
                *ngIf="!associationTabs.selectedIndex && checkPermissions('BUILDING_EDIT') && data.association.type !== 'PRIVATE_SECTOR_COOP'"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addObject' | translate }}</span>
        </button>

        <mat-menu #addObjectMenu class="wide-menu" xPosition="before">
            <button *ngIf="data.association.type !== 'GARAGE_COOP' && data.association.type !== 'PRIVATE_SECTOR_COOP'"
                    (click)="addItem(associationTabs.selectedIndex, {aptUnion: false})"
                    class="item-action-button gray"
                    mat-menu-item>
                <mat-icon class="action-button-icon">playlist_add</mat-icon>
                <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addBuilding' | translate }}</span>
            </button>

            <button *ngIf="data.association.type !== 'GARAGE_COOP' && data.association.type !== 'PRIVATE_SECTOR_COOP'"
                    (click)="addItem(associationTabs.selectedIndex, {aptUnion: true})"
                    class="item-action-button gray"
                    mat-menu-item>
                <mat-icon class="action-button-icon">playlist_add</mat-icon>
                <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addUnion' | translate }}</span>
            </button>

            <button (click)="addItem(associationTabs.selectedIndex, {garage: true})" *ngIf="data.association.type === 'GARAGE_COOP'"
                    class="item-action-button gray"
                    mat-menu-item
            >
                <mat-icon class="action-button-icon">playlist_add</mat-icon>
                <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addGarageRow' | translate }}</span>
            </button>
        </mat-menu>

        <button *ngIf="associationTabs.selectedIndex === 1 && checkPermissions('ASSOCIATION_GOVERNMENT_EDIT')"
                [matMenuTriggerFor]="addGovernmentMenu"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'common.addItem' | translate }}</span>
        </button>

        <mat-menu #addGovernmentMenu class="wide-menu" xPosition="before">
            <button (click)="addItem(associationTabs.selectedIndex, {formType: 'setGroupMainAdmin'})" *ngIf="canAddMainAdmin"
                    class="item-action-button gray"
                    mat-menu-item>
                <mat-icon>settings_accessibility</mat-icon>
                <span>{{ 'Головний адміністратор' | translate }}</span>
            </button>
            <button (click)="addItem(associationTabs.selectedIndex, {formType: 'hidden'})" class="item-action-button gray"
                    mat-menu-item>
                <mat-icon>person_off</mat-icon>
                <span>{{ 'Прихована роль' | translate }}</span>
            </button>
        </mat-menu>

<!--        skip prop !data.disableAddContract-->
        <button *ngIf="(canAddContractSaas || canAddContractAcc || canAddContractPersonal) && associationTabs.selectedIndex === 2 && (checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT'))"
                [matMenuTriggerFor]="chooseContractTypeMenu"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addContract' | translate }}</span>
        </button>

        <mat-menu #chooseContractTypeMenu class="wide-menu" xPosition="before">
            <button (click)="addContract('SAAS')" *ngIf="canAddContractSaas" class="item-action-button gray"
                    mat-menu-item>
                <mat-icon class="action-button-icon">terminal</mat-icon>
                <span>{{ 'modules.billing.agreements.types.SAAS' | translate }}</span>
            </button>
            <button (click)="addContract('ACCOUNTING')" *ngIf="canAddContractAcc" class="item-action-button gray"
                    mat-menu-item>
                <mat-icon class="action-button-icon">person</mat-icon>
                <span>{{ 'modules.billing.agreements.types.ACCOUNTING' | translate }}</span>
            </button>
            <button (click)="addContract('PERSONAL_ACCOUNTING')" *ngIf="canAddContractPersonal" class="item-action-button gray"
                    mat-menu-item>
                <mat-icon class="action-button-icon">supervisor_account</mat-icon>
                <span>{{ 'modules.billing.agreements.types.PERSONAL_ACCOUNTING' | translate }}</span>
            </button>
        </mat-menu>

        <button (click)="addItem(associationTabs.selectedIndex)" *ngIf="associationTabs.selectedIndex === 3 && (checkPermissions('ASSOCIATION_EDIT') || checkPermissions('ORG_MANAGER_EDIT'))"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addManager' | translate }}</span>
        </button>

        <button class="action-button gray" style="height: 32px; width: 32px; padding: 0" [matMenuTriggerFor]="associationItemMenu"
                *ngIf="associationTabs.selectedIndex === 0 && (checkPermissions('ASSOCIATION_EDIT') || checkPermissions('ASSOCIATION_DELETE'))">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #associationItemMenu xPosition="before">
            <button mat-menu-item class="item-action-button gray"
                    (click)="editAssociation()"
                    *ngIf="checkPermissions('ASSOCIATION_EDIT')">
                <mat-icon>edit_note</mat-icon>
                <span>{{'common.buttons.edit' | translate}}</span>
            </button>
            <button mat-menu-item class="item-action-button gray"
                    (click)="blockAssociation()"
                    *ngIf="!data.association.archived && checkPermissions('ASSOCIATION_DELETE')">
                <mat-icon>{{'lock_open'}}</mat-icon>
                <span>{{'common.buttons.block' | translate}}</span>
            </button>
        </mat-menu>
    </div>
    <mat-tab-group #associationTabs (selectedTabChange)="tabChanged($event)" animationDuration="0ms"
                   class="dialog-tabs no-min-with">
        <mat-tab label="{{'modules.clients.associations.associationViewDialog.tabs.main' | translate}}">
            <div class="association-info">
                <div class="key-value grid main-info">
                    <div class="key">{{ 'modules.clients.associations.associationViewDialog.labels.type' | translate }}</div>
                    <div class="value">{{ 'modules.clients.associations.types.' + data.association.type | translate }}</div>

                    <div class="key">{{ 'modules.clients.associations.associationViewDialog.labels.codeName' | translate }}</div>
                    <div class="value">
                        {{ data.association.name }}
                        {{ data.association.code }}
                    </div>

                    <div class="key">{{ 'modules.clients.associations.associationViewDialog.labels.address' | translate }}</div>
                    <div class="value">{{ data.association.address }}</div>

                    <ng-container *ngIf="data.association.type == 'PRIVATE_SECTOR_COOP' || data.association.type == 'GARAGE_COOP'">
                        <div class="key">{{ 'modules.clients.associations.associationViewDialog.labels.location' | translate }}</div>
                        <div class="value link" (click)="openPolygonMap()">Відкрити</div>
                    </ng-container>

                    <div class="key">{{ 'modules.clients.associations.associationViewDialog.labels.finance' | translate }}</div>
                    <div
                            class="value">{{ 'modules.clients.associations.associationViewDialog.labels.finances.' + data.association.financeEnabled | translate }}
                    </div>

                    <canvas #canvas hidden></canvas>
                    <ng-container *ngIf="data.association.type !== 'HOUSING_OFFICE' && data.association.link">
                        <div class="key">{{ 'modules.clients.associations.associationViewDialog.labels.link' | translate }}</div>
                        <div class="value df gap10 jc-s ai-c">
                            <div class="link" cdkCopyToClipboard="{{data.association.link}}">{{ data.association.link }}</div>

                            <div class="link secondary"
                                 [matMenuTriggerFor]="downloadQrMenu">
                                <span>Завантажити QR-код</span>
                            </div>

                            <mat-menu #downloadQrMenu class="wide-menu" xPosition="before">
                                <button (click)="generateAndDownloadPNG(data.association.link)" class="item-action-button gray" mat-menu-item>
                                    <mat-icon>image</mat-icon>
                                    <span>.PNG</span>
                                </button>
                                <button (click)="generateAndDownloadSVG(data.association.link)" class="item-action-button gray" mat-menu-item>
                                    <mat-icon>qr_code</mat-icon>
                                    <span>.SVG</span>
                                </button>
                            </mat-menu>
                        </div>
                    </ng-container>

                    <div class="key">{{ 'ApiToken' | translate }}</div>
                    <div class="value">
                        <div class="df jc-s ai-c gap10">
                            <span (click)="generateApiToken()" class="link">
                                {{ (data.association?.apiToken ? 'modules.clients.associations.associationViewDialog.apiToken.generate.reGenerate' : 'modules.clients.associations.associationViewDialog.apiToken.generate.new') | translate }}
                            </span>

                            <button *ngIf="data.association?.apiToken"
                                    cdkCopyToClipboard="{{data?.association?.apiToken}}"
                                    class="item-action-button gray"
                                    matTooltip="{{'modules.clients.associations.associationViewDialog.apiToken.tooltip.copyToken' | translate}}"
                                    matTooltipClass="tooltip">
                                <mat-icon>content_copy</mat-icon>
                            </button>

                            <button cdkCopyToClipboard="{{environment.openApiLink}}" class="item-action-button gray"
                                    matTooltip="{{'modules.clients.associations.associationViewDialog.apiToken.tooltip.copyLink' | translate}}"
                                    matTooltipClass="tooltip">
                                <mat-icon>add_link</mat-icon>
                            </button>

                            <button (click)="deleteApiToken()"
                                    *ngIf="data.association?.apiToken"
                                    class="item-action-button gray"
                                    matTooltip="{{'modules.clients.associations.associationViewDialog.apiToken.tooltip.deleteToken' | translate}}"
                                    matTooltipClass="tooltip">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="key">{{ 'Тарифний план' }}</div>
                    <div class="value df gap20">
                        <span>{{ 'modules.clients.associations.tariffs.' + data.association.tariff | translate }}</span>
                        <span (click)="changeTariff()" *ngIf="checkPermissions('ASSOCIATION_TARIFF_EDIT')"
                              class="add-row">{{ 'Змінити' }}</span>
                        <span (click)="showTariffHistory()" class="show-info">{{ 'Історія змін' }}</span>
                    </div>
                </div>
                <div class="other-info">
                    <div class="df-c gap10">
                        <button (click)="openCabinet()" *ngIf="checkPermissions('ASSOCIATION_CABINET_ACCESS')"
                                class="action-button blue">
                            <mat-icon>redo</mat-icon>
                            <span>{{ 'modules.clients.associations.associationViewDialog.labels.openCabinet' | translate }}</span>
                        </button>
                        <button (click)="deleteApartments()" *ngIf="checkAllPermissions()" class="action-button red">
                            <mat-icon>delete_forever</mat-icon>
                            <span>{{ 'modules.clients.associations.associationViewDialog.labels.deleteApartments' | translate }}</span>
                        </button>
                        <button (click)="deleteTenants()" *ngIf="checkAllPermissions()" class="action-button red">
                            <mat-icon>delete_forever</mat-icon>
                            <span>{{ 'modules.clients.associations.associationViewDialog.labels.deleteTenants' | translate }}</span>
                        </button>
                    </div>
                    <button (click)="uploadData()" *ngIf="(data.association.type === 'GARAGE_COOP' || data.association.type === 'PRIVATE_SECTOR_COOP')
                        && checkPermissions('ASSOCIATION_EDIT')"
                            class="action-button gray">
                        <mat-icon>file_upload</mat-icon>
                        <span>{{ 'modules.clients.associations.associationViewDialog.labels.uploadData' | translate }}</span>
                    </button>
                </div>
            </div>

            <div *ngIf="buildingDataSource.data && buildingDataSource.data.length > 0"
                 class="table-container">
                <mat-table [dataSource]="buildingDataSource" class="dialog-table">
                    <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.building.address' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fFlex">
                            {{ element.name }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="link">
                        <mat-header-cell *matHeaderCellDef style="width: 300px; min-width: 300px; max-width: 300px;">{{ 'modules.clients.associations.associationViewDialog.labels.link' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 300px; min-width: 300px; max-width: 300px;" class="df gap15">
                            <ng-container *ngIf="element.link">
                                <div class="link" cdkCopyToClipboard="{{element.link}}">{{ element.link }}</div>

                                <div class="link secondary" [matMenuTriggerFor]="downloadQrMenu">
                                    <span>Завантажити QR-код</span>
                                </div>

                                <mat-menu #downloadQrMenu class="wide-menu" xPosition="before">
                                    <button (click)="generateAndDownloadPNG(element.link)" class="item-action-button gray" mat-menu-item>
                                        <mat-icon>image</mat-icon>
                                        <span>.PNG</span>
                                    </button>
                                    <button (click)="generateAndDownloadSVG(element.link)" class="item-action-button gray" mat-menu-item>
                                        <mat-icon>qr_code</mat-icon>
                                        <span>.SVG</span>
                                    </button>
                                </mat-menu>
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="map">
                        <mat-header-cell *matHeaderCellDef style="width: 120px; min-width: 120px; max-width: 120px">{{'modules.clients.associations.associationViewDialog.tables.location' | translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 120px; min-width: 120px; max-width: 120px">
                            <div class="df jc-c ai-s gap5">
                                <mat-icon class="mat-icon-20"
                                          [ngClass]="element?.location
                                            ? element.locationInexactly
                                                ? 'warning-icon'
                                                : 'primary-icon'
                                            : 'red-icon'">map</mat-icon>
                                <div class="value clickable" (click)="openPolygonMap(element.id)">Відкрити</div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 140px; min-width: 140px; max-width: 140px;">{{ 'common.tableActionsColumn' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 140px; min-width: 140px; max-width: 140px;" class="df gap5">
                            <button (click)="uploadData(element)" *ngIf="checkPermissions('BUILDING_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>file_upload</mat-icon>
                            </button>
                            <button (click)="editBuilding(element)" *ngIf="checkPermissions('BUILDING_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            @if (checkAllPermissions() && buildingDataSource.data.length > 1) {
                                <button (click)="deleteBuilding(element)" class="item-action-button gray">
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                            }
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="buildingColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: buildingColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
            <div *ngIf="data.association.type === 'GARAGE_COOP' && garageRowDataSource.data && garageRowDataSource.data.length > 0" class="table-container">
                <mat-table [dataSource]="garageRowDataSource" class="dialog-table">
                    <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef
                                         class="grow">{{ 'modules.clients.associations.associationViewDialog.tables.building.name' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="grow">{{ element.name }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 100px; min-width: 100px; max-width: 100px;">{{ 'common.tableActionsColumn' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 100px; min-width: 100px; max-width: 100px;" class="df gap5">
                            <button (click)="editGarageRow(element)" *ngIf="checkPermissions('BUILDING_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button (click)="deleteGarageRow(element)" *ngIf="checkPermissions('BUILDING_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="garageRowColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: garageRowColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>

        </mat-tab>
        <mat-tab [disabled]="!checkPermissions('ASSOCIATION_GOVERNMENT_READ')"
                 label="{{'modules.clients.associations.associationViewDialog.tabs.roles' | translate}}">
            <div class="table-container">
                <mat-table [dataSource]="roleDataSource" class="dialog-table">

                    <ng-container matColumnDef="user">
                        <mat-header-cell *matHeaderCellDef
                                         class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.roles.user' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fFlex jc-s ai-e gap5">
                            <app-user-item
                                    [avatarLink]="element.user?.userAvatar?.replace('s0', 's64-c')"
                                    [canCall]="true"
                                    [phones]="element.user?.userLogin?.number.split(',')"
                                    [userName]="element.user?.userName?.fullName"
                            ></app-user-item>

                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="roleType">
                        <mat-header-cell *matHeaderCellDef style="width: 45px; min-width: 45px; max-width: 45px">

                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 45px; min-width: 45px; max-width: 45px">
                            <mat-icon *ngIf="element.admin" class="main-admin"
                                      matTooltip="Головний адміністратор"
                                      matTooltipClass="tooltip"
                            >settings_accessibility
                            </mat-icon>
                            <mat-icon *ngIf="element.hidden" class="hidden-role"
                                      matTooltip="Приховаена роль"
                                      matTooltipClass="tooltip"
                            >person_off
                            </mat-icon>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef class="fFlex">
                            <b>{{ 'modules.clients.associations.associationViewDialog.tables.roles.role' | translate }}</b>
                            <span
                                    class="text-normal">&nbsp;/&nbsp;{{ 'modules.clients.associations.associationViewDialog.tables.possitions' | translate }}</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="{'error': element.hidden}" class="fFlex">
                            <div class="df-c">
                                <b *ngIf="element.role?.name">{{ element.role?.name }}</b>
                                <span *ngIf="element.user?.position">{{ element.user?.position }}</span>
                                <span
                                        *ngIf="element.hidden">{{ 'modules.clients.associations.associationRoleDialog.labels.hidden' | translate }}</span>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 100px; min-width: 100px; max-width: 100px">{{ 'common.tableActionsColumn' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 100px; min-width: 100px; max-width: 100px" class="df gap5">
                            <button (click)="editMainRole(element)"
                                    *ngIf="checkPermissions('ASSOCIATION_GOVERNMENT_EDIT') && element.admin"
                                    class="item-action-button gray">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button (click)="deleteRole(element)" *ngIf="checkPermissions('ASSOCIATION_GOVERNMENT_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="roleColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: roleColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
        <mat-tab [disabled]="!checkPermissions('BILLING_NEW_READ') && !checkPermissions('BILLING_SINGLE_CONTRACT_EDIT')"
                 label="{{'Договори'}}">
            <div class="table-container">
                <mat-table [dataSource]="contractsDataSource" class="dialog-table">
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef class="fFlex">{{ 'Договір' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="{'deleted': element.status == 'CANCELLED'}" class="fFlex">
                            {{ element.name }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef
                                         style="width: 150px; min-width: 150px; max-width: 150px">{{ 'modules.billing.agreements.list.table.amount' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="{'deleted': element.status == 'CANCELLED'}" style="width: 150px; min-width: 150px; max-width: 150px">
                            {{ element.amounts.organizationsAmount | currency:'UAH':'грн.':'0.2-2' }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 120px; min-width: 120px; max-width: 120px">{{ 'common.tableActionsColumn' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 120px; min-width: 120px; max-width: 120px" class="df gap5">
                            <button (click)="editContract(element)" *ngIf="!data.disableAddContract && (checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT'))"
                                    class="item-action-button gray">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button (click)="deleteContract(element)" *ngIf="(checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT')) && !element?.counterParty"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="columns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
        <mat-tab [disabled]="!checkPermissions('ORG_MANAGER_READ') && !checkPermissions('ASSOCIATION_EDIT')"
                 label="{{'Managers DAH'}}">
            <div class="table-container">
                <mat-table [dataSource]="managerDataSource" class="dialog-table">

                    <ng-container matColumnDef="manager">
                        <mat-header-cell *matHeaderCellDef
                                         class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.managers.manager' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fFlex">{{ element.manager.name }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef
                                         class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.managers.role' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"
                                  class="fFlex">{{ 'modules.references.administrators.positions.' + element.position | translate }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 80px; min-width: 80px; max-width: 80px">{{ 'common.tableActionsColumn' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 80px; min-width: 80px; max-width: 80px" class="df gap5">
                            <button (click)="deleteManager(element)" *ngIf="checkPermissions('ASSOCIATION_EDIT') || checkPermissions('ORG_MANAGER_EDIT')" [disabled]="!element.id"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="managerColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: managerColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
